<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-dau`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.518 25.692a1 1 0 011.414.025l6.946 7.194a1 1 0 01-.025 1.414l-1.438 1.389A1 1 0 0142 35.689l-2.91-3.015-.182 10.356a1 1 0 01-1.017.982l-2-.035a1 1 0 01-.982-1.017l.18-10.33-2.987 2.886a1 1 0 01-1.414-.024l-1.39-1.439a1 1 0 01.025-1.414l7.194-6.947zM15 3a1 1 0 011 1v2h16V4a1 1 0 011-1h2a1 1 0 011 1v2h4.2c2.03 0 3.693 1.59 3.795 3.594L44 9.79v15.462h-4V22H8v18h15.966v4H7.8a3.796 3.796 0 01-3.795-3.594L4 40.21V9.789c0-2.03 1.6-3.683 3.605-3.784L7.8 6H12V4a1 1 0 011-1h2zm-3 7H8v8h32v-8h-4v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2H16v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconDau',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
